import RFFInputField from '../../form/RFFInputField';
import RFFSelectField from '../../form/RFFSelectField';
import RFFIntegerField from '../../form/RFFIntegerField';
import RFFDecimalField from '../../form/RFFDecimalField';

import {
  required,
  minValue,
  // isNationalItemIdentificationNumber,
  // isNationalStockNumber,
} from '../../../utils/validationUtils';
import { nationalStockNumber } from '../../../utils/parseUtils';

export default [
  {
    name: 'partNum',
    label: 'Part No',
    component: RFFInputField,
    isRequired: true,
    validate: required,
    disabled: true,
  },
  {
    name: 'niin',
    label: 'NSN',
    parse: nationalStockNumber,
    component: RFFInputField,
    disabled: true,
  },

  {
    name: 'description',
    label: 'Description',
    component: RFFInputField,
    toolTip: 'Description is limited to 50 characters',
    maxLength: 50,
  },

  {
    id: 'price',
    name: 'price',
    label: 'Price',
    component: RFFDecimalField,
    isRequired: true,
    validate: minValue(0),
    maxlength: 50,
  },
  {
    id: 'ui',
    name: 'ui',
    label: 'UI',
    isRequired: true,
    component: RFFSelectField,
  },
  {
    id: 'qup',
    name: 'qup',
    label: 'QUP',
    isRequired: true,
    component: RFFSelectField,
  },
  {
    id: 'soh',
    name: 'soh',
    label: 'SOH',
    placeholder: '',
    component: RFFIntegerField,
    isRequired: true,
    validate: minValue(0),
    maxlength: 50,
  },
  {
    id: 'visibility',
    name: 'visibility',
    label: 'Visibility',
    isRequired: true,
    component: RFFSelectField,
  },
];



// WEBPACK FOOTER //
// ./src/components/forms/InventoryManagementDefinitionForm/formConfig.jsx